import { Badges, H6, LI, P, UL } from "../../../AbstractElements";
import { useDispatch } from "react-redux";
import { retrieveCart } from "../../../ReduxToolkit/Reducers/CartReducer";
import { getFormattedPrice } from "../../../services/helper";
import { useEffect } from "react";

export default function HoldCarts({ holdCarts }: { holdCarts: any }) {
  const dispatch = useDispatch();

  // Add keyboard shortcuts for retrieving held carts
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Skip if SweetAlert is open
      if (document.querySelector(".swal2-container")) {
        return;
      }

      // Check for Alt+number combinations (1-9)
      if (e.altKey && e.key >= "1" && e.key <= "9") {
        const cartIndex = parseInt(e.key) - 1;
        if (holdCarts && holdCarts.length > cartIndex) {
          e.preventDefault();
          console.log(
            `Retrieving held cart #${cartIndex + 1} with ID: ${
              holdCarts[cartIndex].id
            }`
          );
          dispatch(retrieveCart(holdCarts[cartIndex].id));
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [dispatch, holdCarts]);

  // Don't show the component if there are no held carts
  if (!holdCarts || holdCarts.length === 0) {
    return (
      <LI className="onhover-dropdown">
        <div className="notification-box onhover-click">
          <i className="fa fa-pause" style={{ color: "white" }}></i>
        </div>
      </LI>
    );
  }

  return (
    <LI className="onhover-dropdown">
      <div className="notification-box onhover-click">
        <i className="fa fa-pause" style={{ color: "white" }}></i>
        <Badges color="success" pill style={{ color: "white" }}>
          {`${holdCarts.length} `}
        </Badges>
      </div>
      <div className="onhover-show-div notification-dropdown">
        <H6 className="f-16 mb-0 py-1 dropdown-title">Hold Carts</H6>
        <div
          className="py-1 px-2 mb-1 bg-dark"
          style={{ borderRadius: "4px", fontSize: "11px" }}
        >
          <strong>Shortcodes:</strong> Alt+1 to Alt+{Math.min(holdCarts.length, 9)}
        </div>
        <UL className="simple-list">
          {holdCarts.map((cart: any, index: any) => (
            <LI
              className="d-flex align-items-center py-1 px-2 hold-cart-item"
              key={index}
              onClick={() => dispatch(retrieveCart(cart.id))}
              title={`Alt+${index + 1}`}
              style={{
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                transition: "background-color 0.2s",
                borderRadius: "4px",
                margin: "1px 0",
              }}
              onMouseOver={(e: any) =>
                (e.currentTarget.style.backgroundColor = "#f5f5f5")
              }
              onMouseOut={(e: any) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              <div style={{ width: "100%" }}>
                <div className="d-flex justify-content-between align-items-center">
                  <P className="mb-0" style={{ fontWeight: "bold", fontSize: "13px" }}>
                    Cart #{index + 1} ({cart.cartItems.length})
                  </P>
                  <span
                    className="badge"
                    style={{
                      fontSize: "11px",
                      padding: "2px 5px",
                      fontWeight: "bold",
                      backgroundColor: "#ffc107",
                      color: "#000",
                    }}
                  >
                    Alt+{index + 1}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span style={{ fontSize: "12px" }}>{cart.cartItems.length} items</span>
                  <span style={{ fontWeight: "bold", color: "#28a745", fontSize: "12px" }}>
                    {getFormattedPrice(cart.total)}
                  </span>
                </div>
              </div>
            </LI>
          ))}
        </UL>
      </div>
    </LI>
  );
}
